var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Popover',{on:{"sureHandler":function($event){return _vm.delByCountryId($event)}},scopedSlots:_vm._u([{key:"tip",fn:function(){return [_c('p',[_vm._v("确定要删除此模板吗！")])]},proxy:true},{key:"reference",fn:function(ref){
var loading = ref.scope;
return [_c('color-text-btn',{staticClass:"update-btn",attrs:{"loading":loading,"size":"mini","type":"danger"}},[_vm._v("删除")])]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }